import * as React from 'react';
import AppRoutes from './components/common/routes/AppRoutes';

const App = () => <AppRoutes />;
export default App;
